import { styled } from "@mui/material";

export const CenterContentContainer = styled("div")({
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  height: "100%",
  width: "100%",
});

export const PieWedge = styled("path")(({ theme }) => ({
  transition: theme.transitions.create(["fill"]),
}));
